import React from 'react';

export default function Badge({ children }) {
  return <span className="trend-badge">{children}</span>;
}
